<template>
  <lu-vbox lu-flex>

    <!-- <lu-vbox v-if='showLogo' class='header-logo'>
        <img v-if="logo" :src="logo" sclass="sidebar-logo">
        <lu-item class='sidebar-title'>{{ appTitle }}</lu-item>
    </lu-vbox> -->

    <lu-vbox lu-flex class="app-wrapper" :class="classObj">
        <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />

        <navbar class='navbar-container' />

        <lu-hbox lu-flex>
          <sidebar class="sidebar-container" />

          <lu-vbox lu-flex class="main-container">


            <app-main class='lu-flex' sv-if='!adminSettings' />

            <!-- <admin-settings class='lu-flex' v-else /> -->

            <right-panel v-if="rightPanelOpened">
              <settings />
            </right-panel>
          </lu-vbox>

          <notificationbar v-if="notificationActive && activeNotificationList && activeNotificationList.length" class="notificationbar-container" />
        </lu-hbox>
    </lu-vbox>
  </lu-vbox>
</template>


<script>
import RightPanel from '@/components/RightPanel'
import { Navbar, Sidebar, AppMain, Notificationbar } from './components' // Settings
import ResizeMixin from './mixin/ResizeHandler'
import { mapState, mapGetters } from 'vuex'
import { LuVbox, LuHbox } from 'lusis-ui'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    RightPanel,
    LuVbox,
    LuHbox,
    Notificationbar
  },
  mixins: [ResizeMixin],
  created () {
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader,
      appTitle: state => state.app.title,
      rightPanelOpened: state => state.app.rightPanelOpened
    }),
    ...mapGetters(['notificationList', 'notificationActive' ]),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    activeNotificationList() {
      return this.notificationList.filter(notif => notif.isRead === 0)
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .drawer-bg {
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    z-index: 9;
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }

</style>
